import React from "react";

import { REACT_APP_URL } from "../../config";

import Button from "@mui/material/Button";

import CustomizedCombinationImage from "../../pages/client/whislist/CustomizedCombinationImage";
import { Link } from "react-router-dom";

const CustomizedCombinationCard = ({
  product,
  selectedCustomizedProduct,
  data,
  setStatus,
  orderProducts,
  handleCancleClick,
  handleAssignArchitectClick,
  isAdmin,
}) => {
  return (
    <tr>
      <td className={data?.isCancelled ? "redrow" : ""}>
        <div className="ImageContainer" style={{ position: "relative" }}>
          {product && product?.image && (
            <Link to={`/customized-combination/${product?._id}`}>
              <img
                loading="lazy"
                src={`${REACT_APP_URL}/images/product/${product?.image}`}
                alt="Image_From_Server"
                className="img-fluid"
                style={{ height: "15vh" }}
              />
            </Link>
          )}

          {selectedCustomizedProduct?.length > 0 &&
            selectedCustomizedProduct?.map((p, i) => {
              return (
                <div key={i}>
                  <CustomizedCombinationImage
                    id={p?.customizedComboRectangleId?._id}
                    productId={product?._id}
                    index={i}
                    customuizedProduct={p?.customizedProductId}
                    combination={p}
                    key={p?._id}
                    PositionX={p?.customizedComboRectangleId?.top}
                    PositionY={p?.customizedComboRectangleId?.left}
                    Height={p?.customizedComboRectangleId?.height}
                    Width={p?.customizedComboRectangleId?.width}
                    updateTotalPrice={() => {}}
                    setCustomizedCombination={() => {}}
                  />
                </div>
              );
            })}
        </div>
      </td>
      <td className={data?.isCancelled ? "redrow" : ""}>
        <p style={{ fontSize: "17px", backgroundColor: "transparent" }}>
          {product?.Name}{" "}
        </p>
      </td>
      <td
        className={data?.isCancelled ? "redrow" : ""}
        style={{ textAlign: "center", fontWeight: "600" }}
      >
        ₹ {data?.productAmount}
      </td>
      <td
        className={data?.isCancelled ? "redrow" : ""}
        style={{ textAlign: "center", fontWeight: "600" }}
      >
        {data?.quantity}
      </td>

      {isAdmin && (
        <td
          className={data?.isCancelled ? "redrow" : ""}
          style={{ textAlign: "center", fontWeight: "600" }}
        >
          {data?.archId?.Name ? (
            data?.archId?.Name
          ) : (
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              title="click here to assign architect"
              onClick={() =>
                handleAssignArchitectClick(
                  orderProducts?._id,
                  data?._id,
                  "customizeComboProducts"
                )
              }
            >
              Assign Architect
            </Button>
          )}
        </td>
      )}
      <td
        className={data?.isCancelled ? "redrow" : ""}
        style={{ textAlign: "right", fontWeight: "600" }}
      >
        {!isAdmin && !data?.isCancelled && (
          <Button
            onClick={() => {
              handleCancleClick(
                orderProducts?._id,
                data?._id,
                "customizeComboProducts"
              );
            }}
            variant="contained"
            disableElevation
            color="error"
            size="small"
          >
            Cancel
          </Button>
        )}
        &nbsp;
        {!isAdmin && (
          <Button
            onClick={() => setStatus(data)}
            variant="contained"
            disableElevation
            color="success"
            size="small"
            style={{ backgroundColor: "#475B52" }}
          >
            Status
          </Button>
        )}
        &nbsp;
        {isAdmin && (
          <Button
            href={`/admin/order/status/customizeComboProducts/${orderProducts?._id}/${data?._id}`}
            variant="outlined"
            color="success"
            size="small"
          >
            Update Status
          </Button>
        )}
        &nbsp;
        {isAdmin && (
          <Button
            href={`/customized-combination/${product?._id}`}
            variant="outlined"
            color={data?.isCancelled ? "primary" : "warning"}
            size="small"
          >
            View Product
          </Button>
        )}
        {data?.isCancelled && (
          <p style={{ textAlign: "left" }}>Reason : {product?.cancelReason}</p>
        )}
      </td>
    </tr>
  );
};

export default CustomizedCombinationCard;
